// extracted by mini-css-extract-plugin
module.exports = {"none":"ReviewPriorityIndicator_none__3n7bT","low":"ReviewPriorityIndicator_low__1tr_W","high":"ReviewPriorityIndicator_high__2CMTI"};